import styled from "styled-components";

export const ContainerCardConfig = styled.div`
  width: 462px;
  height: 284px;
  background-color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  border-radius: 24px;
  color: var(--color-latex10);
  h1,
  h2 {
    text-align: start;
    margin: 0;
    width: 352px;
  }
  h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
  }
  h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 150%;
  }
  input {
    width: 352px;
    height: 36px;
    background: var(--color-grey97);
    border: 2px solid var(--color-grey90);
    padding-left: 10px;
  }
  button {
    width: 304px;
    height: 45px;
    font-weight: 500;
    font-size: 18px;
    border-radius: 8px;
    border: none;
    background-color: var(--color-primary);
    color: var(--color-white);
    gap: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
